import { useParams } from 'react-router-dom';

import { PollSlideTypes } from '../../../../../../db/types';
import { PollParams } from '../../../../../../routes/router';
import { enumFromStringValue } from '../../../../../../utils/string';

const useSlideIdentifier = () => {
  const { slideType: slideTypeValues } = useParams<PollParams>();
  const slideType = enumFromStringValue(PollSlideTypes, slideTypeValues);
  return { slideType };
};

export default useSlideIdentifier;
